import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./locales/setup";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

(async () => {
  const App = (await import("./App")).default;

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
})();
